import React, { Component } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.min.css";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
let player = null;
let startTime = 0;
class TestVideoPlayer extends Component {
  constructor() {
    super();
    this.videoTag = React.createRef();
  }
  state = {
    logs: [],
    videoUrl: "",
  };

  componentDidMount() {
    const self = this;
    const vid = this.videoTag.current;
    let hls = {
      nativeAudioTracks: false,
      nativeVideoTracks: false,
    };
    const options = {
      html5: {
        hls: hls,
      },
      techOrder: ["html5"],
      autoplay: false,
    };
    player = videojs(vid, options);
    player.bigPlayButton.off("click");

    player.bigPlayButton.on("click", function () {
      if (this.player_.paused()) {
        this.player_.play();
      } else {
        this.player_.pause();
      }
    });

    player.on("playing", () => {
      let currentTime = new Date().getTime();
      let diffTime = (currentTime - startTime) / 1000;
      let log = `Playback started in ${diffTime} seconds`;
      let newArr = JSON.parse(JSON.stringify(this.state.logs));
      newArr.push(log);
      this.setState({
        logs: newArr,
      });
    });

    var open = window.XMLHttpRequest.prototype.open,
      send = window.XMLHttpRequest.prototype.send;
    function openReplacement(method, url) {
      this._url = url;
      this.addEventListener("loadstart", function (e) {});
      this.addEventListener("loadend", function (e) {
        let currentTime = new Date().getTime();
        let diffTime = (currentTime - startTime) / 1000;
        // startTime = currentTime;
        let log = `${diffTime} seconds took to fetch ${url}`;
        let newArr = JSON.parse(JSON.stringify(self.state.logs));
        newArr.push(log);
        self.setState({
          logs: newArr,
        });
      });
      this.addEventListener("loadstart", (e) => {
        console.log('load evt: ', e)
      });
      return open.apply(this, arguments);
    }
    function sendReplacement() {
      return send.apply(this, arguments);
    }
    window.XMLHttpRequest.prototype.open = openReplacement;
    window.XMLHttpRequest.prototype.send = sendReplacement;
  }

  onUrlChange = (e) => {
    this.setState({
      videoUrl: e.target.value,
    });
  };

  clearLogs = () => {
    this.setState({
      logs: [],
    });
  };

  startVideo = () => {
    let source = this.state.videoUrl;
    player.src({
      type: "application/x-mpegurl",
      src: source,
    });
    startTime = new Date().getTime();
    player.play();
    let log = `On play in 0 seconds`;
    let newArr = JSON.parse(JSON.stringify(this.state.logs));
    newArr.push(log);
    this.setState({
      logs: newArr,
    });
  };
  render() {
    return (
      <Grid direction="row" container spacing={2}>
        <Grid item xs={12} lg={4} md={4}>
          <video-js
            ref={this.videoTag}
            class="vjs-default-skin player vjs-fluid vjs-16-9 vjs-big-play-centered"
            controls
            muted="muted"
          ></video-js>
        </Grid>
        <Grid item xs={12} lg={8} md={8}>
          <Grid container alignItems="flex-end" justify="flex-start">
            <Grid item xs={7}>
              <TextField
                fullWidth
                id="standard-basic"
                label="Enter video url"
                onChange={this.onUrlChange}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.startVideo}
                disabled={!this.state.videoUrl}
              >
                Play
              </Button>
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.clearLogs}
                disabled={!this.state.logs.length}
              >
                Clear Logs
              </Button>
            </Grid>

            <Grid item xs={12}>
              {this.state.logs.length > 0 && (
                <List component="nav" aria-label="secondary mailbox folders">
                  {this.state.logs.map((item) => {
                    return (
                      <ListItem key={Math.random()}>
                        <ListItemText primary={item} />
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default TestVideoPlayer;
//https://multiplatform-f.akamaihd.net/i/multi/will/bunny/big_buck_bunny_,640x360_400,640x360_700,640x360_1000,950x540_1500,.f4v.csmil/master.m3u8
//https://multiplatform-f.akamaihd.net/i/multi/will/bunny/big_buck_bunny_,640x360_400,640x360_700,640x360_1000,950x540_1500,.f4v.csmil/master.m3u8
